import React, { useEffect, useRef, useState } from 'react';
import { FilterAltIcon } from 'cokitchen-icons';

export type SelectOption<T extends string> = { text: string; value: T };

type Props<T extends string> = {
  label: string;
  items: SelectOption<T>[];
  selected: T[];
  onToggle: (value: T) => void;
  isActive?: boolean;
  widthClassName?: string;
};

const MultiSelectDropdown = <T extends string>({
  label,
  items,
  selected,
  onToggle,
  isActive = false,
  widthClassName = 'w-[114px]'
}: Props<T>) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (!wrapperRef.current?.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  return (
    <div className='relative' ref={wrapperRef}>
      <button
        type='button'
        onClick={() => setOpen((prev) => !prev)}
        className={`border border-[#E5E6E6] rounded-[5px] text-xs leading-[19px] h-[36px] flex px-2 justify-between items-center ${widthClassName} cursor-pointer`}>
        <span className='text-[#5E6164] text-sm capitalize'>{label}</span>
        <FilterAltIcon className={isActive ? 'text-red-5' : 'text-[#5E6164]'} />
      </button>
      {open && (
        <div
          className={`absolute left-0 top-full z-20 mt-1 ${widthClassName} rounded-[5px] border border-[#E5E6E6] bg-white py-1 shadow-sm`}>
          {items.map(({ text, value }) => (
            <button
              key={value}
              type='button'
              onClick={() => onToggle(value)}
              className={`w-full px-2 py-2 text-left text-xs capitalize hover:bg-[#F2F2F3] ${
                selected.includes(value) ? 'text-red-5' : ''
              }`}>
              {text}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropdown;
